/** @format */

import React, { useCallback, useEffect, useState } from "react";
import HOC from "../../layout/HOC";
import { deleteApi, editApi, getApi, postApi } from "../../../Respo/Api";
import TableLayout from "../../../Component/TableLayout";
import { FaPen, FaRegTrashAlt } from "react-icons/fa";
import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import { WebPages } from "../../../Helper/Constant";
import {
  CustomPagination,
  ReactSelect,
} from "../../../Component/HelpingComponents";
import FullScreenLoader from "../../../Component/FullScreenLoader";

const MetaTags = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchHandler = useCallback(() => {
    const queryParams = new URLSearchParams({
      limit: 10,
      page,
    });

    const url = `api/v1/MetaTag/getMetaTag?${queryParams?.toString()}`;
    getApi({
      url,
      setResponse,
      setLoading,
    });
  }, [page]);

  useEffect(() => {
    fetchHandler();
  }, [fetchHandler]);

  const removeHandler = (id) => {
    deleteApi({
      url: `api/v1/MetaTag/${id}`,
      additionalFunctions: [fetchHandler],
      setLoading,
      successMsg: "Removed !",
    });
  };

  const returnPageLabel = (value) => {
    const result = WebPages.filter((i) => i.value === value);
    return result?.[0]?.label;
  };

  const tableHead = ["Sno.", "Title", "Description", "Connected page", ""];

  const tableBody = response?.data?.docs?.map((item, index) => [
    `# ${index + 1}`,
    item?.title,
    item?.description,
    <span>
      {(item?.page && returnPageLabel(item.page)) ||
        (item?.serviceId && `Service / ${item?.serviceId?.name}`) ||
        (item?.productId && `Product / ${item?.productId?.name}`) ||
        (item?.newsId && `Blog / ${item?.newsId?.title}`)}
    </span>,
    <span className="flexCont">
      <span className="remove-icon" onClick={() => removeHandler(item?._id)}>
        <FaRegTrashAlt />
      </span>
      <span
        className="edit-icon"
        onClick={() => {
          setIsEdit(true);
          setSelectedItem(item);
          setIsOpen(true);
        }}
      >
        <FaPen />
      </span>
    </span>,
  ]);

  function MyVerticallyCenteredModal(props) {
    // State declarations remain the same
    const [page, setPage] = useState("");
    const [description, setDescription] = useState("");
    const [title, setTitle] = useState("");
    const [productId, setProductId] = useState({});
    const [serviceId, setServiceId] = useState({});
    const [typeOfPage, setTypeOfPage] = useState("");
    const [products, setProducts] = useState(null);
    const [services, setServices] = useState(null);
    const [limitedServices, setLimitedService] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [allNews, setAllNews] = useState(null);
    const [newsId, setNewsId] = useState({});
    const [category, setCategory] = useState(null);
    const [categoryId, setCategoryId] = useState({});
    const [brand, setBrands] = useState(null);
    const [brandId, setBrandId] = useState({});
    const [nutrition, setNutrition] = useState(null);
    const [nutritionId, setNutritionId] = useState({});
    const [productType, setProductType] = useState(null);
    const [productTypeId, setProductTypeId] = useState({});
    const [skinCondition, setSkinCondition] = useState(null);
    const [skinConditionId, setSkinConditionId] = useState({});
    const [skinType, setSkinType] = useState(null);
    const [skinTypeId, setSkinTypeId] = useState({});

    // Helper function to fetch data with error handling
    const fetchData = async (url, setResponse) => {
      try {
        await getApi({ url, setResponse });
      } catch (error) {
        console.error(`Error fetching ${url}:`, error);
        // You could add user feedback here (e.g., toast notification)
      }
    };

    const fetchNews = () => fetchData("api/v1/News/getNews", setAllNews);
    const fetchCategory = () => fetchData("api/v1/admin/Category/allCategory", setCategory);
    const fetchBrand = () => fetchData("api/v1/admin/Brand/allBrand", setBrands);
    const fetchNutrition = () => fetchData("api/v1/admin/Nutrition/allNutrition", setNutrition);
    const fetchProductType = () => fetchData("api/v1/admin/ProductType/allProductType", setProductType);
    const fetchSkinCondition = () => fetchData("api/v1/admin/SkinCondition/allSkinCondition", setSkinCondition);
    const fetchSkinType = () => fetchData("api/v1/admin/SkinType/allSkinType", setSkinType);

    useEffect(() => {
      if (props.show) {
        fetchNews();
        fetchCategory();
        fetchBrand();
        fetchNutrition();
        fetchProductType();
        fetchSkinCondition();
        fetchSkinType();
      }
    }, [props.show]); // Only run when props.show changes

    // Data fetching effects remain the same
    useEffect(() => {
      if (typeOfPage === "service" && categoryId?.value) {
        fetchData(`api/v1/Service/all/paginateServiceSearch?categoryId=${categoryId.value}`, setServices);
      }
    }, [categoryId, typeOfPage]);

    useEffect(() => {
      if (typeOfPage === "product") {
        // Check if at least one filter has a value
        const hasActiveFilter =
          brandId?.value ||
          skinTypeId?.value ||
          nutritionId?.value ||
          productTypeId?.value ||
          skinConditionId?.value;

        if (hasActiveFilter) {
          const params = new URLSearchParams({
            brandId: brandId?.value || '',
            skinTypeId: skinTypeId?.value || '',
            nutritionId: nutritionId?.value || '',
            productTypeId: productTypeId?.value || '',
            skinConditionId: skinConditionId?.value || '',
            limit: 100
          });

          fetchData(`api/v1/Product/all/paginateProductSearch?${params}`, setProducts);
        } else {
          // Clear products when no filters are selected
          setProducts(null);
        }
      }
    }, [brandId, skinTypeId, skinConditionId, productTypeId, nutritionId, typeOfPage]);

    // Initialize form when in edit mode
    useEffect(() => {
      if (props.isEdit && props.selectedItem) {
        const item = props.selectedItem;
        setTitle(item?.title || '');
        setDescription(item?.description || '');
        setPage(item?.page || '');

        // Set IDs for different page types
        if (item.productId) {
          setProductId({
            value: item?.productId?._id,
            label: item?.productId?.name,
          });
        }
        if (item.serviceId) {
          setServiceId({
            value: item?.serviceId?._id,
            label: item?.serviceId?.name,
          });
        }
        if (item.newsId) {
          setNewsId({
            value: item?.newsId?._id,
            label: item?.newsId?.name,
          });
        }

        // Determine page type
        if (item?.page) {
          setTypeOfPage("normal");
        } else if (item?.serviceId) {
          setTypeOfPage("service");
        } else if (item?.productId) {
          setTypeOfPage("product");
        } else {
          setTypeOfPage("news");
        }
      } else {
        // Reset form when creating new
        setTitle('');
        setDescription('');
        setPage('');
        setProductId({});
        setServiceId({});
        setNewsId({});
        setTypeOfPage('');
      }
    }, [props.isEdit, props.selectedItem]);

    const transformToOptions = (data, valueKey = '_id', labelKey = 'name') => {
      return data?.length > 0
        ? data.map(item => ({ value: item[valueKey], label: item[labelKey] }))
        : [];
    };

    const newsOptions = transformToOptions(allNews?.data, '_id', 'title');
    const productOptions = transformToOptions(products?.data?.docs);
    const categoryOption = transformToOptions(category?.data);
    const regularServiceOption = transformToOptions(services?.data?.docs);
    const limitedServiceOption = transformToOptions(limitedServices?.data);
    const combinedServices = [...regularServiceOption, ...limitedServiceOption];
    const brandOption = transformToOptions(brand?.data);
    const nutritionOption = transformToOptions(nutrition?.data);
    const productTypeOption = transformToOptions(productType?.data);
    const skinConditionOption = transformToOptions(skinCondition?.data);
    const skinTypeOption = transformToOptions(skinType?.data);

    const getFilterLabels = () => {
      const activeFilters = [];

      if (brandId?.label) activeFilters.push(brandId.label);
      if (nutritionId?.label) activeFilters.push(nutritionId.label);
      if (productTypeId?.label) activeFilters.push(productTypeId.label);
      if (skinConditionId?.label) activeFilters.push(skinConditionId.label);
      if (skinTypeId?.label) activeFilters.push(skinTypeId.label);

      return activeFilters.join(' ');
    };


    const payload = {
      page,
      description,
      title,
      productId: productId?.value,
      serviceId: serviceId?.value,
      newsId: newsId?.value,
    };

    const handleSubmit = (e) => {
      e.preventDefault();

      if (!title || !description) {
        alert("Please fill in all required fields");
        return;
      }

      setSubmitLoading(true);

      const apiCall = props.isEdit
        ? editApi({
          url: `api/v1/MetaTag/updateMetaTag/${props.selectedItem?._id}`,
          payload,
          setLoading: setSubmitLoading,
          successMsg: "Meta tag updated successfully!",
          additionalFunctions: [() => props.onHide(), props.fetchHandler],
        })
        : postApi({
          url: "api/v1/MetaTag/addMetaTag",
          payload,
          setLoading: setSubmitLoading,
          successMsg: "Meta tag created successfully!",
          additionalFunctions: [() => props.onHide(), props.fetchHandler],
        });

      apiCall.catch(error => {
        console.error("Error saving meta tag:", error);
      });
    };

    const resetProductFilters = () => {
      setBrandId({});
      setNutritionId({});
      setProductTypeId({});
      setSkinConditionId({});
      setSkinTypeId({});
      setProductId({});
    };



    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="md" // Make modal larger for better readability
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.isEdit ? "Edit Meta Tag" : "Create New Meta Tag"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {submitLoading && <FullScreenLoader />}
          <Form onSubmit={handleSubmit}>
            <div className="mb-4">
              <h5 className="mb-3">Basic Information</h5>
              <Form.Group className="mb-3">
                <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter meta title (50-60 characters recommended)"
                  maxLength="60"
                />
                <Form.Text className="text-muted">
                  This will appear in browser tabs and search results.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                <FloatingLabel label="Enter meta description">
                  <Form.Control
                    as="textarea"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    required
                    style={{ height: '100px' }}
                    placeholder="Enter meta description (150-160 characters recommended)"
                    maxLength="160"
                  />
                </FloatingLabel>
                <Form.Text className="text-muted">
                  This will appear in search results under the title.
                </Form.Text>
              </Form.Group>
            </div>

            <div className="mb-4">
              <h6 className="mb-3">Page Targeting</h6>
              <Form.Group className="mb-3">
                <Form.Label>Page Type <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  required
                  value={typeOfPage}
                  onChange={(e) => setTypeOfPage(e.target.value)}
                  className="form-select-lg"
                >
                  <option value="">Select a page type...</option>
                  <option value="normal">Standard Page</option>
                  <option value="product">Product Page</option>
                  <option value="service">Service Page</option>
                  <option value="news">Blog/News Page</option>
                </Form.Select>
                <Form.Text className="text-muted">
                  Select where this meta tag will be applied.
                </Form.Text>
              </Form.Group>

              {typeOfPage === "normal" && (
                <Form.Group className="mb-3">
                  <Form.Label>Select Page <span className="text-danger">*</span></Form.Label>
                  <Form.Select
                    required
                    value={page}
                    onChange={(e) => setPage(e.target.value)}
                    className="form-select-lg"
                  >
                    <option value="">Select a page...</option>
                    {WebPages.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              {typeOfPage === "product" && (
                <div className="border p-3 rounded mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Product Filters</h6>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={resetProductFilters}
                      disabled={!brandId.value && !nutritionId.value && !productTypeId.value &&
                        !skinConditionId.value && !skinTypeId.value && !productId.value}
                    >
                      Reset Filters
                    </Button>
                  </div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Brand</Form.Label>
                        <ReactSelect
                          options={brandOption}
                          value={brandId}
                          setValue={setBrandId}
                          placeholder="Filter by brand..."
                          isClearable
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Nutrition</Form.Label>
                        <ReactSelect
                          options={nutritionOption}
                          value={nutritionId}
                          setValue={setNutritionId}
                          placeholder="Filter by nutrition..."
                          isClearable
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Product Type</Form.Label>
                        <ReactSelect
                          options={productTypeOption}
                          value={productTypeId}
                          setValue={setProductTypeId}
                          placeholder="Filter by product type..."
                          isClearable
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Skin Condition</Form.Label>
                        <ReactSelect
                          options={skinConditionOption}
                          value={skinConditionId}
                          setValue={setSkinConditionId}
                          placeholder="Filter by skin condition..."
                          isClearable
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Skin Type</Form.Label>
                        <ReactSelect
                          options={skinTypeOption}
                          value={skinTypeId}
                          setValue={setSkinTypeId}
                          placeholder="Filter by skin type..."
                          isClearable
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group className="mt-3">
                    <Form.Label>Select Product <span className="text-danger">*</span></Form.Label>
                    <ReactSelect
                      options={productOptions}
                      value={productId}
                      setValue={setProductId}
                      placeholder="Select a product..."
                      isDisabled={!brandId && !skinTypeId && !nutritionId && !productTypeId && !skinConditionId}
                    />
                    {(!brandId && !skinTypeId && !nutritionId && !productTypeId && !skinConditionId) && (
                      <Form.Text className="text-muted">
                        Please select at least one filter above to see available products.
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              )}

              {typeOfPage === "service" && (
                <div className="border p-3 rounded mb-3">
                  <h6 className="mb-3">Service Filters</h6>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Category</Form.Label>
                        <ReactSelect
                          options={categoryOption}
                          value={categoryId}
                          setValue={setCategoryId}
                          placeholder="Select a category..."
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group>
                    <Form.Label>Select Service <span className="text-danger">*</span></Form.Label>
                    <ReactSelect
                      options={combinedServices}
                      value={serviceId}
                      setValue={setServiceId}
                      placeholder="Select a service..."
                      isDisabled={!categoryId}
                    />
                    {!categoryId && (
                      <Form.Text className="text-muted">
                        Please select a category first to see available services.
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              )}

              {typeOfPage === "news" && (
                <Form.Group className="mb-3">
                  <Form.Label>Select Blog/News <span className="text-danger">*</span></Form.Label>
                  <ReactSelect
                    options={newsOptions}
                    value={newsId}
                    setValue={setNewsId}
                    placeholder="Select a blog/news item..."
                  />
                </Form.Group>
              )}
            </div>

            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="outline-secondary"
                onClick={props.onHide}
                disabled={submitLoading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={submitLoading}
              >
                {submitLoading ? 'Saving...' : 'Save Meta Tag'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal1(props) {
    const [page, setPage] = useState("");
    const [description, setDescription] = useState("");
    const [title, setTitle] = useState("");
    const [productId, setProductId] = useState({});
    const [serviceId, setServiceId] = useState({});
    const [typeOfPage, setTypeOfPage] = useState("");
    const [products, setProducts] = useState(null);
    const [services, setServices] = useState(null);
    const [limitedServices, setLimitedService] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [allNews, setAllNews] = useState(null);
    const [newsId, setNewsId] = useState({});
    const [category, setCategory] = useState(null)
    const [categoryId, setCategoryId] = useState({})


    const [brand, setBrands] = useState(null)
    const [brandId, setBrandId] = useState({})
    const [nutrition, setNutrition] = useState(null)
    const [nutritionId, setNutritionId] = useState({})
    const [productType, setProductType] = useState(null)
    const [productTypeId, setProductTypeId] = useState({})
    const [skinCondition, setSkinCondition] = useState(null)
    const [skinConditionId, setSkinConditionId] = useState({})
    const [skinType, setSkinType] = useState(null)
    const [skinTypeId, setSkinTypeId] = useState({})


    const fetchNews = () => {
      getApi({
        url: "api/v1/News/getNews",
        setResponse: setAllNews,
      });
    };

    const fetchCategory = () => {
      getApi({
        url: `api/v1/admin/Category/allCategory`,
        setResponse: setCategory,
      });
    };
    const fetchBrand = () => {
      getApi({
        url: `api/v1/admin/Brand/allBrand`,
        setResponse: setBrands,
      });
    };
    const fetchNutrition = () => {
      getApi({
        url: `api/v1/admin/Nutrition/allNutrition`,
        setResponse: setNutrition,
      });
    };
    const fetchProductType = () => {
      getApi({
        url: `api/v1/admin/ProductType/allProductType`,
        setResponse: setProductType,
      });
    };
    const fetchSkinCondition = () => {
      getApi({
        url: `api/v1/admin/SkinCondition/allSkinCondition`,
        setResponse: setSkinCondition,
      });
    };
    const fetchSkinType = () => {
      getApi({
        url: `api/v1/admin/SkinType/allSkinType`,
        setResponse: setSkinType,
      });
    };

    useEffect(() => {
      if (props.show) {
        // fetchProducts();
        fetchNews();
        fetchCategory();
        fetchBrand();
        fetchNutrition();
        fetchProductType();
        fetchSkinCondition();
        fetchSkinType();
      }
    }, [props]);

    useEffect(() => {
      if (typeOfPage === "service" && categoryId?.value) {
        getApi({
          url: `api/v1/Service/all/paginateServiceSearch?categoryId=${categoryId.value}`,
          setResponse: setServices,
        });
      }
    }, [categoryId, typeOfPage]);

    useEffect(() => {
      if (typeOfPage === "product" && brandId?.value) {
        getApi({
          url: `api/v1/Product/all/paginateProductSearch?brandId=${brandId.value ? brandId.value : ''}&skinTypeId=${skinTypeId.value ? skinTypeId.value : ''}&nutritionId=${nutritionId.value ? nutritionId.value : ''}&productTypeId=${productTypeId.value ? productTypeId.value : ''}&skinConditionId=${skinConditionId.value ? skinConditionId.value : ''}`,
          setResponse: setProducts,
        });
      }
    }, [brandId, skinTypeId, skinConditionId, productTypeId, nutritionId, typeOfPage]);




    useEffect(() => {
      if (props.isEdit && props.selectedItem) {
        const item = props.selectedItem;
        setTitle(item?.title);
        setDescription(item?.description);
        setPage(item?.page);

        if (item.productId) {
          setProductId({
            value: item?.productId?._id,
            label: item?.productId?.name,
          });
        }
        if (item.serviceId) {
          setServiceId({
            value: item?.serviceId?._id,
            label: item?.serviceId?.name,
          });
        }
        if (item.newsId) {
          setNewsId({
            value: item?.newsId?._id,
            label: item?.newsId?.name,
          });
        }

        if (item?.page) {
          setTypeOfPage("normal");
        } else if (item?.serviceId) {
          setTypeOfPage("service");
        } else if (item?.productId) {
          setTypeOfPage("product");
        } else {
          setTypeOfPage("news");
        }
      }
    }, [props]);

    const newsOptions = allNews?.data?.map((item) => ({
      value: item?._id,
      label: item?.title,
    }));

    const productOptions =
      products?.data?.docs?.length > 0
        ? products?.data?.docs?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];

    const categoryOption =
      category?.data?.length > 0
        ? category?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];

    const regularServiceOption =
      services?.data?.docs?.length > 0
        ? services?.data?.docs?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];

    const limitedServiceOption =
      limitedServices?.data?.length > 0
        ? limitedServices?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];

    const combinedServices = [...regularServiceOption, ...limitedServiceOption];


    const brandOption =
      brand?.data?.length > 0
        ? brand?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];
    const nutritionOption =
      nutrition?.data?.length > 0
        ? nutrition?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];
    const productTypeOption =
      productType?.data?.length > 0
        ? productType?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];
    const skinConditionOption =
      skinCondition?.data?.length > 0
        ? skinCondition?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];
    const skinTypeOption =
      skinType?.data?.length > 0
        ? skinType?.data?.map((item) => ({
          value: item?._id,
          label: item?.name,
        }))
        : [];

    const payload = {
      page,
      description,
      title,
      productId: productId?.value,
      serviceId: serviceId?.value,
      newsId: newsId?.value,
    };

    const addNew = (e) => {
      e.preventDefault();

      if (props.isEdit) {
        editApi({
          url: `api/v1/MetaTag/updateMetaTag/${props.selectedItem?._id}`,
          payload,
          setLoading: setSubmitLoading,
          successMsg: "Updated !",
          additionalFunctions: [() => props.onHide(), props.fetchHandler],
        });
        return;
      }
      postApi({
        url: "api/v1/MetaTag/addMetaTag",
        payload,
        setLoading: setSubmitLoading,
        successMsg: "Created !",
        additionalFunctions: [() => props.onHide(), props.fetchHandler],
      });
    };




    return (
      <>
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Create New
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {submitLoading && <FullScreenLoader />}
            <Form onSubmit={addNew}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <FloatingLabel label="Description">
                  <Form.Control
                    as="textarea"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    required
                  />
                </FloatingLabel>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Type of page</Form.Label>
                <Form.Select
                  required
                  value={typeOfPage}
                  onChange={(e) => setTypeOfPage(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="normal">Home Page</option>
                  <option value="product">Product Detail Page</option>
                  <option value="service">Service Detail Page</option>
                  <option value="news">Blogs</option>
                </Form.Select>
              </Form.Group>

              {typeOfPage === "normal" && (
                <Form.Group className="mb-3">
                  <Form.Label>Select Desirable Page</Form.Label>
                  <Form.Select
                    required
                    value={page}
                    onChange={(e) => setPage(e.target.value)}
                  >
                    <option value="">Select</option>
                    {WebPages.map((item) => (
                      <option value={item.value} key={item}>
                        {" "}
                        {item.label}{" "}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              {typeOfPage === "product" && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Brand</Form.Label>
                    <ReactSelect
                      options={brandOption}
                      value={brandId}
                      setValue={setBrandId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Nutrition</Form.Label>
                    <ReactSelect
                      options={nutritionOption}
                      value={nutritionId}
                      setValue={setNutritionId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select ProductType</Form.Label>
                    <ReactSelect
                      options={productTypeOption}
                      value={productId}
                      setValue={setProductId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Skin Condition</Form.Label>
                    <ReactSelect
                      options={skinConditionOption}
                      value={skinConditionId}
                      setValue={setSkinConditionId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Skin Type</Form.Label>
                    <ReactSelect
                      options={skinTypeOption}
                      value={skinTypeId}
                      setValue={setSkinTypeId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Desirable Product</Form.Label>
                    <ReactSelect
                      options={productOptions || []}
                      value={productId}
                      setValue={setProductId}
                    />
                  </Form.Group>
                </>
              )}

              {typeOfPage === "service" && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Category</Form.Label>
                    <ReactSelect
                      options={categoryOption}
                      value={categoryId}
                      setValue={setCategoryId}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Desirable Service</Form.Label>
                    <ReactSelect
                      options={combinedServices}
                      value={serviceId}
                      setValue={setServiceId}
                    />
                  </Form.Group>
                </>
              )}

              {typeOfPage === "news" && (
                <Form.Group className="mb-3">
                  <Form.Label>Select Desirable Blog</Form.Label>
                  <ReactSelect
                    options={newsOptions}
                    value={newsId}
                    setValue={setNewsId}
                  />
                </Form.Group>
              )}

              <Button
                style={{ backgroundColor: "#042b26", borderRadius: "0" }}
                type="submit"
              >
                Submit
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    );
  }

  return (
    <section className="sectionCont">
      <MyVerticallyCenteredModal
        show={isOpen}
        fetchHandler={fetchHandler}
        onHide={() => setIsOpen(false)}
        isEdit={isEdit}
        selectedItem={selectedItem}
      />
      <div
        className="pb-4   w-full flex justify-between items-center"
        style={{
          position: "sticky",
          top: 0,
          paddingTop: "1.5rem",
          backgroundColor: "#fff",
        }}
      >
        <span
          className="tracking-widest text-slate-900 font-semibold"
          style={{ fontSize: "1.5rem" }}
        >
          Meta Tags
        </span>
        <button
          className="md:py-2 px-3 md:px-4 py-1 rounded-sm bg-[#042b26] text-white tracking-wider"
          onClick={() => setIsOpen(true)}
        >
          Create New
        </button>
      </div>

      <TableLayout thead={tableHead} tbody={tableBody} loading={loading} />
      <CustomPagination
        currentPage={page}
        setCurrentPage={setPage}
        hasNextPage={response?.data?.hasNextPage}
        hasPrevPage={response?.data?.hasPrevPage}
      />
    </section>
  );
};

export default HOC(MetaTags);
